import type { TagDesignTokens } from '@primeuix/themes/types/tag';

/**
 * Tag component tokens
 *
 * Reference implementation:
 * https://github.com/primefaces/primeuix/blob/main/packages/themes/src/presets/aura/tag/index.ts
 *
 * Component documentation:
 * https://primeng.org/tag
 */
export const tagComponentTokens: Partial<TagDesignTokens> = {
  root: {
    fontSize: '1rem',
    fontWeight: '600',
  },
  icon: {
    size: '1rem',
  },
  colorScheme: {
    light: {
      warn: {
        color: '{yellow.900}',
        background: '{yellow.200}',
      },
    },
  },
};
